import GuideCompleteContainer from './GuideCompleteContainer';

export default GuideCompleteContainer;
